const functionEvaluators = {
    AND: ps => ps.every(p => p),
    OR: ps => ps.some(p => p),
    NOT: ps => !ps[0] ,
    NAND: ps => !ps.every(p => p),
    NOR: ps => !ps.some(p => p),
    XOR: ps => ps.filter(p => p).length % 2 === 1,
    XNOR: ps => ps.filter(p => p).length % 2 === 0,

    IF: ps => {
        if (ps[0]) {
            return ps[1];
        }
        
        return ps[2];
    },

    IFELSEIF: ps => {
        for (let i = 0; i < ps.length; i += 2) {
            if (ps[i]) {
                return ps[i + 1];
            }
        }
        
        return ps[ps.length - 1];
    },
    
    LESSTHAN: ps => ps[0] < ps[1],
    LESSTHANOREQUALS: ps => ps[0] <= ps[1],
    GREATERTHAN: ps => ps[0] > ps[1],
    GREATERTHANOREQUALS: ps => ps[0] >= ps[1],
    BETWEEN: ps => ps[1] <= ps[0] && ps[0] <= ps[2],

    SUM: ps => ps.reduce((acc, curr) => acc + curr),
    ADD: ps => ps.reduce((acc, curr) => acc + curr),
    SUBTRACT: ps => ps.reduce((acc, curr) => acc - curr),
    MULTIPLY: ps => ps.reduce((acc, curr) => acc * curr),
    DIVIDE: ps => ps.reduce((acc, curr) => acc / curr),
    ABSOLUTEVALUE: ps => Math.abs(ps[0]),
    
    DATETIME: ps => new Date(ps[0]),
    DATE: ps => new Date(ps[0].split("T")[0]),
    TIME: ps => { throw "Not implemented" },
    YEAR: ps => new Date(ps[0]).getFullYear(),
    MONTH: ps => new Date(ps[0]).getMonth(),
    DAY: ps => new Date(ps[0]).getDate(),
    DATEADD: ps => { throw "Not implemented" },
    DATEDIFF: ps => { throw "Not implemented" },
    NOW: _ => new Date(),
    TODAY: _ => {
        const now = new Date();
        
        return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    },

    // TODO: Good enough?
    EQUALS: ps => ps[0] === ps[1],
    NOTEQUALS: ps => ps[0] !== ps[1],
    CONCATENATE: ps => ps[0].toString() + ps[1].toString(),
    IN: ps => ps.slice(1).some(p => p === ps[0]),

    BOOL: ps => ps[0].toString().toLowerCase() === "true",
    STRING: ps => ps[0].toString(),
    BYTE: ps => parseInt(ps[0]),
    INT: ps => parseInt(ps[0]),
    LONG: ps => parseInt(ps[0]),
    DECIMAL: ps => parseFloat(ps[0]),
    ISNULL: ps => ps[0] == null
};

function parse(functionString, data, evaluateReferences) {
    const functions = [];
    let Hopper = "";
    let stringOpen = false;
    let escapeOpen = false;

    for (let i = 0; i < functionString.length; i++) {
        let character = functionString[i];

        if (character === '(' && !stringOpen) {
            const func = {
                FunctionType: Hopper,
                Parameters: []
            }

            functions.push(func);
            stringOpen = false;
            Hopper = "";
        } else if (character === '[' && !stringOpen) {
            //skip this character
        } else if (character === ']' && !stringOpen) {
            if (evaluateReferences) {
                if (data[Hopper] === undefined) {
                    functions[functions.length - 1].Parameters.push(null);
                }

                functions[functions.length - 1].Parameters.push(data[Hopper]);
            } else {
                functions[functions.length - 1].Parameters.push({ ReferenceName: Hopper });
            }

            stringOpen = false;
            Hopper = "";
        } else if (character === '"') {
            if (escapeOpen) {
                Hopper += '"';
                escapeOpen = false;
            } else if (stringOpen) {
                const strFunction = {
                    FunctionType: "STRING",
                    Parameters: []
                };

                strFunction.Parameters.push(Hopper);

                if (functions.length > 0) {
                    functions[functions.length - 1].Parameters.push(strFunction);
                } else if (functions.length === 0) {
                    //console.log('ret str function: ', strFunction);
                    return strFunction;
                }

                stringOpen = false;
                Hopper = "";
            } else {
                stringOpen = true;
            }
        } else if (character === ')' && !stringOpen) {
            if (Hopper != "") {
                const typedValue = parseType(Hopper);
                
                functions[functions.length - 1].Parameters.push(typedValue);

                stringOpen = false;
                Hopper = "";
            }

            if (functions.length > 1) {
                functions[functions.length - 2]
                    .Parameters
                    .push(functions[functions.length - 1])
                ;

                functions.pop();
            } else if (functions.length === 1) {
                //console.log('ret func: ', functions);
                return functions[0];
            }
        } else if (character === ',' && !stringOpen) {
            if (Hopper === "") {
                //skips adding ',' to Hopper
            } else {
                const typedValue = parseType(Hopper);
                const last = functions[functions.length - 1];
                //console.log('typed val: ', typedValue);
                last.Parameters.push(typedValue);

                stringOpen = false;
                Hopper = "";
            }
        } else if (!character.trim()) {
            if (stringOpen) {
                Hopper += character;
            }
        } else if (character === "\\") {
            if (escapeOpen) {
                Hopper += character;
                escapeOpen = false;
            } else {
                escapeOpen  = true;
            }
        } else {
            Hopper += character;
        }
    }
    //console.log('functions: ', functions);
    return functions[0];
}

function evaluateFunction(func) {
   // console.log('evaluate function: ', func);
    for (let i = 0; i < func.Parameters.length; i++) {
        const param = func.Parameters[i];

        if (typeof(param) === "object") {
            try {
               // console.log('param: ', param);
                if(param !== null && param !== undefined){
                    param.EvaluatedValue = evaluateFunction(param).EvaluatedValue;
                } else {
                   // console.log('param skipped: ', param);
                }
                
            } catch (e) {
               // console.log('error::');
                throw e;
            }
        }
    }

    const parameters = [];

    for (let i = 0; i < func.Parameters.length; i++) {
        const param = func.Parameters[i];

        if (typeof(param) === "object" && param !== null) {
            parameters.push(param.EvaluatedValue);
        } else {
            parameters.push(param);
        }
    }

    if (functionEvaluators.hasOwnProperty(func.FunctionType)) {
        func.EvaluatedValue = functionEvaluators[func.FunctionType](parameters);
        
    } else {
        throw "The function " + func.FunctionType + "has not been implemented properly in the EvaluateFunction method.";
    }
   // console.log('func evaluated: ', func);
    return func;
}

function getValidationMessages(func) {
    return [];
}

function parseType(token) {
    const pattern = '(^-?[0-9]+$)|(^-?[0-9][0-9.]*$)|(^null$)|(^true$)|(^false$)|(^"(?:[\\].|[^\\"])*"$)|(^".*$)|:(.*)|(^[^"]*$)';

    const regex = new RegExp(pattern);
    const match = token.match(regex);

    if (match === null) {
        throw "Unrecognized token '" + token + "'";
    }

    if (match[1] !== undefined) {
        return parseInt(match[1]);
    }

    if (match[2] !== undefined) {
        return parseFloat(match[1]);
    }

    if (match[3] !== undefined) {
        return null;
    }

    if (match[4] !== undefined) {
        return true;
    }

    if (match[5] !== undefined) {
        return false;
    }

    return token;
}

function evaluate(functionString, data) {
    data = data || {};
   // console.log('entry: func str: ', functionString);
    const f = parse(functionString, data, true);
  //  console.log('f: after parse', f);
    if (f === null) {
        return null;
    }

    const validationMessages = getValidationMessages(f);
   // console.log(' val msgs: ', validationMessages);

    if (validationMessages.length > 0) {
        throw validationMessages.join(". ");
    }
   // console.log('f: right before ret ', f);
    return evaluateFunction(f).EvaluatedValue;
}

export default {
    evaluate: evaluate
}